import React from 'react';
import './App.css';
import BusinessList from '../BusinessList/BusinessList';
import SearchBar from '../SearchBar/SearchBar';
import Yelp from '../../util/Yelp';

const business1 = {
  imageSrc: './img/5205.png',
  price: 'CA$899.9K',
  address: '5205 Green Crescent',
  city: 'Regina',
  province: 'SK',
  zipCode: 'S4V 3S9',
  category: 'House',
  bed_no: 4,
  bath_no: 3,
  rating: 5,
  reviewCount: 21,
}

const business2 = {
  imageSrc: './img/232.png',
  price: 'CA$428.9K',
  address: '232 Rue Bayview',
  city: 'Pincourt',
  province: 'QC',
  zipCode: 'J7W 3W9',
  category: 'House',
  bed_no: 5,
  bath_no: 2,
  rating: 4.6,
  reviewCount: 38
}

const business3 = {
  imageSrc: './img/2040.png',
  price: 'CA$243.9K',
  address: '213-2040 Ottawa Ave',
  city: 'Brandon',
  province: 'MB',
  zipCode: 'R7B 4A9',
  category: 'Apartment',
  bed_no: 1,
  bath_no: 1,
  rating: 3.2,
  reviewCount: 18
}

const business4 = {
  imageSrc: './img/236.png',
  price: 'CA$599K',
  address: '236 Claridge Dr',
  city: 'Ottawa',
  province: 'ON',
  zipCode: 'K2J 5H1',
  category: 'Townhouse',
  bed_no: 3,
  bath_no: 4,
  rating: 4.1,
  reviewCount: 46
}

const business5 = {
  imageSrc: './img/233.png',
  price: 'CA$699K',
  address: '3009-233 Robson St',
  city: 'Vancouver',
  province: 'BC',
  zipCode: 'V6B 0E8',
  category: 'Apartment',
  bed_no: 1,
  bath_no: 1,
  rating: 4,
  reviewCount: 6
}

const business6 = {
  imageSrc: './img/615.png',
  price: 'CA$214.9K',
  address: '615 Goulding St',
  city: 'Winnipeg',
  province: 'MB',
  zipCode: 'R3G 2S3',
  category: 'House',
  bed_no: 2,
  bath_no: 1,
  rating: 3.6,
  reviewCount: 86
}

const business7 = {
  imageSrc: './img/60.png',
  price: 'CA$899K',
  address: '60 Muzzo Dr',
  city: 'Brampton',
  province: 'ON',
  zipCode: 'L6R 3W9',
  category: 'Townhouse',
  bed_no: 3,
  bath_no: 3,
  rating: 4.6,
  reviewCount: 73
}

const business8 = {
  imageSrc: './img/323.png',
  price: 'CA$146.9K',
  address: '323 16th St',
  city: 'Brandon',
  province: 'MB',
  zipCode: 'R7A 4X7',
  category: 'House',
  bed_no: 2,
  bath_no: 2,
  rating: 3.4,
  reviewCount: 90
}

const businesses = [
  business1,
  business2,
  business3,
  business4,
  business5,
  business6,
  business7,
  business8 
];

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      businesses: [],
    }
    this.searchYelp = this.searchYelp.bind(this);
  }

  searchYelp(term, location, sortBy) {
    Yelp.searchYelp(term, location, sortBy).then((businesses) => {
      this.setState({businesses: businesses});
    });
  }

  render() {
    return (
      
      <div className='App'>
        <h1>MD's Realty</h1>
        <h2>Your Dream Home Awaits…</h2>
  
        <BusinessList businesses={businesses} />
        <SearchBar searchYelp={this.searchYelp} />
        <BusinessList businesses={this.state.businesses} />
      </div>
    );
  }
}

export default App;